import React from 'react'

import {Helmet} from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Navbar from '../components/navbar'
import Hero17 from '../components/hero17'
import Features24 from '../components/features24'
import CTA26 from '../components/cta26'
import Features25 from '../components/features25'
import Steps2 from '../components/steps2'
import Testimonial17 from '../components/testimonial17'
import Contact10 from '../components/contact10'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  const { t, i18n } = useTranslation()
  return (
    <div className="home-container">
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('meta.siteTitle')}</title>
        <meta name="description" content={t('meta.description')} />
        <meta name="keywords" content={t('meta.keywords')} />
        <meta name="author" content="Pic-nic d'Opale" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Language alternatives */}
        <link rel="alternate" hrefLang="fr" href="https://picnic-opale.fr/fr" />
        <link rel="alternate" hrefLang="en" href="https://picnic-opale.fr/en" />
        <link rel="alternate" hrefLang="nl" href="https://picnic-opale.fr/nl" />
        <link rel="alternate" hrefLang="de" href="https://picnic-opale.fr/de" />
        <link rel="alternate" hrefLang="x-default" href="https://picnic-opale.fr/" />

        {/* Open Graph meta tags */}
        <meta property="og:title" content={t('meta.siteTitle')} />
        <meta property="og:description" content={t('meta.description')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://picnic-opale.fr" />
        <meta property="og:image" content="https://picnic-opale.fr/picnicOpale-small.jpg" />
        <meta property="og:locale" content={i18n.language === 'fr' ? 'fr_FR' : i18n.language === 'nl' ? 'nl_NL' : i18n.language === 'de' ? 'de_DE' : 'en_GB'} />
        <meta property="og:locale:alternate" content="en_GB" />
        <meta property="og:locale:alternate" content="nl_NL" />
        <meta property="og:locale:alternate" content="de_DE" />
        <meta property="og:site_name" content="Pic-nic d'Opale" />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta.siteTitle')} />
        <meta name="twitter:description" content={t('meta.description')} />
        <meta name="twitter:image" content="https://picnic-opale.fr/picnicOpale-small.jpg" />

        {/* Additional SEO meta tags */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://picnic-opale.fr" />

        {/* Structured Data: Apartment */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Apartment",
            "name": t('meta.siteTitle'),
            "description": t('meta.description'),
            "url": "https://picnic-opale.fr",
            "image": "https://picnic-opale.fr/picnicOpale-small.jpg",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Wimereux",
              "addressRegion": "Hauts-de-France",
              "addressCountry": "FR"
            },
            "areaServed": "Wimereux, Côte d'Opale",
            "inLanguage": i18n.language
          })}
        </script>
      </Helmet>
      <Navbar />
      <Hero17/>
      <Features24/>
      <CTA26/>
      <Features25/>
        {/*<Steps2/>
      <Testimonial17/>*/}
      <Contact10/>
      <Footer />
    </div>
  )
}

export default Home
